import Repository from '../repository'

export default {
  async Authenticate (data) {
    const response = await Repository.post('login', data, { headers: { 'Content-Type': 'multipart/form-data' } })
    return response.data;
  }
}

